export default "__VITE_ASSET__DRtS9qJI__"